<template>
  <div class="box-hero -degradate" :style="backgroundimage ? `background-image: url(${backgroundimage})` : ''">
    <div class="box-text container">
      <div class="row row-responsive">
        <div class="column column-xs-100 -centered-info">
          <h1 class="maintitle -medium" v-html="maintitle"></h1>
        </div>
        <div class="column -centered-info" v-if="secondarytitle">
          <p class="secondarytitle" v-html="secondarytitle"></p>
        </div>
        <div class="column -centered-info" v-if="ctatext">
          <router-link :to="{name: ctaroute}" class="button button-large ctabutton">{{ ctatext }}</router-link>
        </div>
      </div>
    </div>
    <div v-if="additionalinfo" v-html="additionalinfo"></div>
  </div>
</template>

<script>

export default {
  name: 'BoxHero',
  props: ['maintitle', 'secondarytitle', 'additionalinfo', 'ctaroute', 'ctatext', 'backgroundimage'],
  data () {
    return {
    }
  }
}

</script>

<style lang="scss" scoped>

.box-hero {
  position: relative;
  padding: 8rem 0 5rem;
  background: url('/static/images/bg-home.jpg') center center no-repeat;
  background-size: cover;
  color: $white;

  .secondarytitle {
    font-size: 1.5em;
  }

  .ctabutton {
    margin-top: 2rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/partials/BoxHero.vue